import { DefaultService } from '@/services/DefaultService';

export default class DespesaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }
    
    save(form) {
        return this._http.post(`${this._env}/despesa/despesa`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Erro ao cadastrar despesa');
        });

    }

    findAllDespesasByIdusuario(idusuario, idacerto) {
        return this._http.get(`${this._env}/despesa/despesa/listbyuser.json?idusuario=${idusuario}&idacerto=${idacerto}`, this._headers)
            .then(res => {
                return res.body;
            }, err => {
                this.verifyError(err);
                throw err;
            });
    }

    findAllFotosDespesasByIdDespesa(iddespesa) {
        return this._http.get(`${this._env}/despesa/fotosbyiddespesa.json?iddespesa=${iddespesa}`, this._headers)
            .then(res => {
                return res.body;
            }, err => {
                this.verifyError(err);
                throw err;
            });
    }

    find(id) {
        return this._http.get(`${this._env}/despesa/despesa/${id}.json`, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(iddespesa_motivo, column, order, page, limit, params) {
        return this._http.get(`${this._env}/despesa/despesa.json?iddespesa_motivo=${iddespesa_motivo}&column=${column}&order=${order}&page=${page}&limit=${limit}&param=${params}`, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error("Problems while jobs are loading");
        });
    }

    updateSituacao(despesa) {
        return this._http.post(`${this._env}/despesa/despesa/updatesituacao`, despesa, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error("Problems while jobs are loading");
        });
    }
}